module.exports = __webpack_public_path__ + "static/media/Solar Panel.244d6df1.png";